/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { isInt } from 'validator';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
  InputAdornment,
  Box,
  TextField,
  Button,
  MenuItem,
  Autocomplete,
  Grid,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/pt-br';
import dayjs from 'dayjs';
import axios from '../../services/axios';
import { ContainerGrid, Title } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import * as actions from '../../store/modules/auth/actions';
import NumberFormatCustom from '../../utils/NumberFormatCustom';

dayjs.locale('pt-br');

export default function Cadastro() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const userId = useSelector((state) => state.auth.user.id);

  const today = dayjs();

  const [descricao, setDescricao] = useState('');
  const [lancamento, setLancamento] = useState(dayjs(today));
  const [valor, setValor] = useState('');
  const [tipo_acao, setTipoAcao] = useState(0);
  const [tipo_manutencao, setTipoManutencao] = useState(0);
  const [id_funcionario, setIdFuncionario] = useState('');
  const [id_favorecido, setIdFavorecido] = useState('');
  const [id_tipodespesa, setIdTipoDespesa] = useState('');
  const [id_detalhe, setIdDetalhe] = useState('');
  const [id_veiculo, setIdVeiculo] = useState('');
  const [id_carreta, setIdCarreta] = useState('');
  const [id_empresa, setIdEmpresa] = useState('');
  const [tableDataTipoDespesa, setTableDataTipoDespesa] = useState([]);
  const [tableDataDetalhe, setTableDataDetalhe] = useState([]);
  const [tableDataFuncionario, setTableDataFuncionario] = useState([]);
  const [tableDataEmpresa, setTableDataEmpresa] = useState([]);
  const [tableDataFavorecido, setTableDataFavorecido] = useState([]);
  const [tableDataVeiculo, setTableDataVeiculo] = useState([]);
  const [tableDataCarreta, setTableDataCarreta] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const textData = 'Controle de Despesa';
  // const tableData = 'controledespesa';
  const tableDatas = 'controledespesas';

  async function getData() {
    try {
      setIsLoading(true);

      const { data } = await axios.get(`/${tableDatas}/${id}`);
      setDescricao(data.descricao);
      setLancamento(dayjs(data.lancamento));
      setValor(data.valor);
      setIdFuncionario(data.id_funcionario);
      setIdFavorecido(data.id_favorecido);
      setIdTipoDespesa(data.id_tipodespesa);
      setIdDetalhe(data.id_detalhe);
      setIdVeiculo(data.id_veiculo);
      setIdCarreta(data.id_carreta);
      setTipoAcao(data.tipo_acao);
      setTipoManutencao(data.tipo_manutencao);
      setIdEmpresa(data.id_empresa);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/${tableDatas}`);
    }
  }

  async function getDataDropdown() {
    try {
      setIsLoading(true);
      let responsekey = await axios.get('/funcionarios');
      setTableDataFuncionario(responsekey.data);

      responsekey = await axios.get('/empresas');
      setTableDataEmpresa(responsekey.data);

      responsekey = await axios.get('/veiculos');
      setTableDataVeiculo(responsekey.data);

      responsekey = await axios.get('/carretas');
      setTableDataCarreta(responsekey.data);

      responsekey = await axios.get('/favorecidos');
      setTableDataFavorecido(responsekey.data);

      responsekey = await axios.get('/tipodespesas');
      setTableDataTipoDespesa(responsekey.data);

      responsekey = await axios.get('/tipodespesadetalhes');
      setTableDataDetalhe(responsekey.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/${tableDatas}`);
    }
  }

  async function fetchFuncionario(idUser) {
    try {
      setIsLoading(true);
      const { data } = await axios.get(`/users/${idUser}`); // Endpoint que retorna o usuário logado
      if (data.Funcionario && data.Funcionario.id) {
        setIdFuncionario(data.Funcionario.id); // Define o id_funcionario
      } else {
        toast.error('Funcionário associado ao usuário não encontrado.');
      }
      if (data.Funcionario && data.Funcionario.id_empresa) {
        setIdEmpresa(data.Funcionario.id_empresa); // Define o id_funcionario
      } else {
        toast.error('Empresa associado ao funcionário não encontrado.');
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);
      if (status === 400) errors.map((error) => toast.error(error));
      toast.error('Erro ao buscar funcionário do usuário logado.');
    }
  }

  useEffect(() => {
    async function fetchData() {
      await getDataDropdown();
      if (id) {
        // se for alteração
        await getData();
      }
      await fetchFuncionario(userId);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formErrors = false;

    if (!lancamento || lancamento === 'NaN') {
      toast.error('Data Lançamento inválido');
      formErrors = true;
    }

    if (!isInt(String(id_empresa))) {
      toast.error('Id da Empresa inválido');
      formErrors = true;
    }

    if (!isInt(String(id_funcionario))) {
      toast.error('Id do Funcionário inválido');
      formErrors = true;
    }

    if (!isInt(String(id_tipodespesa))) {
      toast.error('Id do Tipo de Despesa inválido');
      formErrors = true;
    }

    if (!isInt(String(id_detalhe))) {
      toast.error('Id Detalhe inválido');
      formErrors = true;
    }

    if (!valor) {
      toast.error('Valor inválido');
      formErrors = true;
    }

    /* if (descricao.length < 3 || descricao.length > 255) {
      toast.error('Descrição precisa ter entre 3 e 255 caracteres');
      formErrors = true;
    } */

    /* if (!isInt(String(id_favorecido))) {
      setIdFavorecido(id_favorecido);
      toast.error('Id do Favorecido inválido');
      formErrors = true;
    } */

    /* if (!isInt(String(id_veiculo))) {
      toast.error('Id do Veículo inválido');
      formErrors = true;
    } */

    if (!isInt(String(tipo_acao))) {
      toast.error('Tipo de Ação inválido');
      formErrors = true;
    }

    if (!isInt(String(tipo_manutencao))) {
      toast.error('Tipo de Manutenção inválido');
      formErrors = true;
    }

    if (formErrors) return;

    try {
      setIsLoading(true);
      if (id) {
        await axios.put(`/${tableDatas}/${id}`, {
          id_funcionario,
          id_empresa,
          id_favorecido: id_favorecido || null,
          id_tipodespesa,
          id_veiculo: id_veiculo || null,
          id_carreta: id_carreta || null,
          descricao,
          lancamento,
          valor,
          id_detalhe,
          tipo_acao,
          tipo_manutencao,
        });
        toast.success(`Alterado com sucesso!`);
        navigate(`/${tableDatas}/`);
      } else {
        await axios.post(`/${tableDatas}/`, {
          id_funcionario,
          id_empresa,
          id_favorecido: id_favorecido || null,
          id_tipodespesa,
          id_veiculo: id_veiculo || null,
          id_carreta: id_carreta || null,
          descricao,
          lancamento,
          valor,
          id_detalhe,
          tipo_acao,
          tipo_manutencao,
          cancelamento: null,
        });
        toast.success(`Cadastrado com sucesso!`);
        navigate(`/${tableDatas}/`);
      }

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const data = get(err, 'response.data', {});
      const errors = get(data, 'errors', []);

      if (errors.length > 0) {
        errors.map((error) => toast.error(error));
      } else {
        toast.error('Erro desconhecido');
      }

      if (status === 401) dispatch(actions.loginFailure());
    }
  };

  const tipoAcao = [
    { nome: 'Nenhuma', id: 0 },
    { nome: 'Corretiva', id: 1 },
    { nome: 'Preventiva', id: 2 },
  ];
  const tipoManutencao = [
    { nome: 'Nenhuma', id: 0 },
    { nome: 'Elétrica', id: 1 },
    { nome: 'Mecânica', id: 2 },
  ];

  return (
    <ContainerGrid>
      <Loading isLoading={isLoading} />
      <Title>{id ? `Alterar ${textData}` : `Novo ${textData}`}</Title>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                required
                label="Data Lançamento"
                size="small"
                value={lancamento}
                onChange={(e) => setLancamento(e)}
                format="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6} />
          <Grid item xs={12} sm={6}>
            <Autocomplete
              disabled
              id={id_empresa ? String(id_empresa) : ''}
              value={
                tableDataEmpresa.find((option) => option.id === id_empresa) ||
                null
              }
              options={tableDataEmpresa}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdEmpresa(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  required
                  label="Empresa"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              disabled
              id={id_funcionario ? String(id_funcionario) : ''}
              value={
                tableDataFuncionario.find(
                  (option) => option.id === id_funcionario
                ) || null
              }
              options={tableDataFuncionario}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdFuncionario(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  required
                  label="Funcionário"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_tipodespesa ? String(id_tipodespesa) : ''}
              value={
                tableDataTipoDespesa.find(
                  (option) => option.id === id_tipodespesa
                ) || null
              }
              options={tableDataTipoDespesa}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdTipoDespesa(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  required
                  label="Tipo de Despesa"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              required
              value={
                tableDataDetalhe.some(
                  (table) => table.id_tipodespesa === id_tipodespesa
                )
                  ? id_detalhe
                  : ''
              }
              label="Detalhe"
              size="small"
              onChange={(e) => setIdDetalhe(e.target.value)}
            >
              {tableDataDetalhe
                .filter((table) => table.id_tipodespesa === id_tipodespesa)
                .map((table) => (
                  <MenuItem key={table.id} value={table.id_detalhe}>
                    {table.Detalhe.nome}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              value={valor}
              label="Valor"
              size="small"
              onChange={(e) => setValor(e.target.value)}
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_favorecido}
              value={
                tableDataFavorecido.find(
                  (option) => option.id === id_favorecido
                ) || null
              }
              options={tableDataFavorecido}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdFavorecido(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  label="Favorecido"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_veiculo}
              value={
                tableDataVeiculo.find((option) => option.id === id_veiculo) ||
                null
              }
              options={tableDataVeiculo}
              getOptionLabel={(option) => option.placa}
              onChange={(event, newValue) => {
                setIdVeiculo(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  label="Veículo"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_carreta}
              value={
                tableDataCarreta.find((option) => option.id === id_carreta) ||
                null
              }
              options={tableDataCarreta}
              getOptionLabel={(option) => option.placa}
              onChange={(event, newValue) => {
                setIdCarreta(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  label="Carreta"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              select
              value={tipo_acao}
              label="Tipo de Ação"
              onChange={(e) => setTipoAcao(e.target.value)}
              size="small"
            >
              {tipoAcao.map((table) => (
                <MenuItem key={table.id} value={table.id}>
                  {table.nome}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              select
              value={tipo_manutencao}
              label="Tipo Manutenção"
              onChange={(e) => setTipoManutencao(e.target.value)}
              size="small"
            >
              {tipoManutencao.map((table) => (
                <MenuItem key={table.id} value={table.id}>
                  {table.nome}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              value={descricao}
              label="Observação"
              onChange={(e) => setDescricao(e.target.value)}
              size="small"
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              type="button"
              color="secondary"
              variant="contained"
              onClick={handleSubmit}
            >
              {id ? 'Alterar' : 'Cadastrar'}
            </Button>
            <Button type="button" onClick={() => navigate(`/${tableDatas}`)}>
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </ContainerGrid>
  );
}
